exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-repayment .responsiveMobile option-switch{width:100%}loans-repayment .no-loan{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}loans-repayment .no-loan .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}loans-repayment option-switch{width:370px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansRepayment/loansRepayment.scss
// module id = 2035
// module chunks = 0